/**
 * PublicBackButton — thin, pill-shaped "back" chip rendered just below
 * PublicHeader on interior public pages (Pricing, Features, Blog list,
 * etc.). Uses browser history when possible, falls back to the home
 * page so it never becomes a dead-end.
 *
 * Usage:
 *   <PublicHeader/>
 *   <PublicBackButton to="/" label="Back to home"/>
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PublicBackButton({ to = "/", label = "Back", testid = "public-back" }) {
  const nav = useNavigate();
  const go = () => {
    if (window.history.length > 1) nav(-1);
    else nav(to);
  };
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-4">
      <button
        type="button"
        onClick={go}
        data-testid={testid}
        className="group inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur border border-emerald-100 hover:border-emerald-300 hover:bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-all"
      >
        <ArrowLeft className="w-4 h-4 text-emerald-700 transition-transform group-hover:-translate-x-0.5"/>
        {label}
      </button>
    </div>
  );
}
